import { render, staticRenderFns } from "./application-detail.vue?vue&type=template&id=fd630988&scoped=true"
import script from "./application-detail.vue?vue&type=script&lang=js"
export * from "./application-detail.vue?vue&type=script&lang=js"
import style0 from "./application-detail.vue?vue&type=style&index=0&id=fd630988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd630988",
  null
  
)

export default component.exports